import SvgIcon from '@mui/material/SvgIcon';

const ExternalUserHeaderLogoIcon = () => {
    return (
        <SvgIcon fontSize="large">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_ii_1721_45)">
                    <rect x="6.25" y="5.9375" width="27.5" height="27.5" rx="7.34375" fill="#13335F" />
                </g>
                <foreignObject x="1.74812" y="6.46687" width="23.6192" height="26.91">
                    <div
                        xmlns="http://www.w3.org/1999/xhtml"
                        style={{
                            backdropFilter: 'blur(1.3px)',
                            clipPath: 'url(#bgblur_0_1721_45_clip_path)',
                            height: '100%',
                            width: '100%',
                        }}
                    ></div>
                </foreignObject>
                <g filter="url(#filter1_i_1721_45)" data-figma-bg-blur-radius="2.59563">
                    <path
                        d="M13.5578 19.9219C16.5283 19.9219 18.9326 17.4931 18.9326 14.4922C18.9326 11.4913 16.5283 9.0625 13.5578 9.0625C10.5872 9.0625 8.18292 11.4913 8.18292 14.4922C8.18292 17.4931 10.5872 19.9219 13.5578 19.9219ZM17.2434 21.4732H16.8451C15.8469 21.958 14.7383 22.2489 13.5578 22.2489C12.3772 22.2489 11.2735 21.958 10.2705 21.4732H9.87216C6.82002 21.4732 4.34375 23.9748 4.34375 27.058V28.4542C4.34375 29.7389 5.37553 30.7813 6.64725 30.7813H20.4683C21.74 30.7813 22.7718 29.7389 22.7718 28.4542V27.058C22.7718 23.9748 20.2955 21.4732 17.2434 21.4732Z"
                        fill="#2496FF"
                        fillOpacity="0.69"
                    />
                    <path
                        d="M13.5578 19.9219C16.5283 19.9219 18.9326 17.4931 18.9326 14.4922C18.9326 11.4913 16.5283 9.0625 13.5578 9.0625C10.5872 9.0625 8.18292 11.4913 8.18292 14.4922C8.18292 17.4931 10.5872 19.9219 13.5578 19.9219ZM17.2434 21.4732H16.8451C15.8469 21.958 14.7383 22.2489 13.5578 22.2489C12.3772 22.2489 11.2735 21.958 10.2705 21.4732H9.87216C6.82002 21.4732 4.34375 23.9748 4.34375 27.058V28.4542C4.34375 29.7389 5.37553 30.7813 6.64725 30.7813H20.4683C21.74 30.7813 22.7718 29.7389 22.7718 28.4542V27.058C22.7718 23.9748 20.2955 21.4732 17.2434 21.4732Z"
                        fill="url(#paint0_linear_1721_45)"
                    />
                </g>
                <foreignObject x="20.6832" y="8.40437" width="17.7462" height="23.6192">
                    <div
                        xmlns="http://www.w3.org/1999/xhtml"
                        style={{
                            backdropFilter: 'blur(1.3px)',
                            clipPath: 'url(#bgblur_1_1721_45_clip_path)',
                            height: '100%',
                            width: '100%',
                        }}
                    ></div>
                </foreignObject>
                <g filter="url(#filter2_i_1721_45)" data-figma-bg-blur-radius="2.59563">
                    <path
                        d="M32.719 15.607C32.719 18.1505 30.6263 20.214 28.0469 20.214C25.4675 20.214 23.3747 18.1505 23.3747 15.607C23.3747 13.0636 25.4675 11 28.0469 11C30.6263 11 32.719 13.0636 32.719 15.607Z"
                        fill="#FF9100"
                    />
                    <path
                        d="M30.2756 21.7497H30.383C33.3955 21.7497 35.8338 24.154 35.8338 27.1245C35.8338 28.3962 34.7874 29.428 33.4977 29.428H25.2116C25.0436 29.428 24.9321 29.2889 24.9321 29.1209V27.2781C24.9321 25.6382 24.3486 24.1375 23.3908 22.9391C23.2012 22.7018 23.2546 22.3432 23.5322 22.2201C24.1994 21.9243 24.9311 21.7497 25.7108 21.7497H25.8181C25.8695 21.7497 25.9205 21.7582 25.9693 21.7744C26.6241 21.9909 27.3151 22.1336 28.0469 22.1336C28.7786 22.1336 29.4697 21.9909 30.1245 21.7744C30.1732 21.7582 30.2243 21.7497 30.2756 21.7497Z"
                        fill="#FF9100"
                    />
                </g>
                <defs>
                    <filter
                        id="filter0_ii_1721_45"
                        x="6.25"
                        y="4.88061"
                        width="28.0284"
                        height="29.1819"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                        <feOffset dx="0.528447" dy="-1.05689" />
                        <feGaussianBlur stdDeviation="1.51928" />
                        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                        <feBlend mode="multiply" in2="shape" result="effect1_innerShadow_1721_45" />
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                        <feOffset dy="0.625" />
                        <feGaussianBlur stdDeviation="0.3125" />
                        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
                        <feBlend mode="normal" in2="effect1_innerShadow_1721_45" result="effect2_innerShadow_1721_45" />
                    </filter>
                    <filter
                        id="filter1_i_1721_45"
                        x="1.74812"
                        y="6.46687"
                        width="23.6192"
                        height="26.91"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                        <feOffset />
                        <feGaussianBlur stdDeviation="1.55738" />
                        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0.858333 0 0 0 0 0.95841 0 0 0 0 1 0 0 0 1 0" />
                        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1721_45" />
                    </filter>
                    <clipPath id="bgblur_0_1721_45_clip_path" transform="translate(-1.74812 -6.46687)">
                        <path d="M13.5578 19.9219C16.5283 19.9219 18.9326 17.4931 18.9326 14.4922C18.9326 11.4913 16.5283 9.0625 13.5578 9.0625C10.5872 9.0625 8.18292 11.4913 8.18292 14.4922C8.18292 17.4931 10.5872 19.9219 13.5578 19.9219ZM17.2434 21.4732H16.8451C15.8469 21.958 14.7383 22.2489 13.5578 22.2489C12.3772 22.2489 11.2735 21.958 10.2705 21.4732H9.87216C6.82002 21.4732 4.34375 23.9748 4.34375 27.058V28.4542C4.34375 29.7389 5.37553 30.7813 6.64725 30.7813H20.4683C21.74 30.7813 22.7718 29.7389 22.7718 28.4542V27.058C22.7718 23.9748 20.2955 21.4732 17.2434 21.4732Z" />
                    </clipPath>
                    <filter
                        id="filter2_i_1721_45"
                        x="20.6832"
                        y="8.40437"
                        width="17.7462"
                        height="23.6192"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                        <feOffset />
                        <feGaussianBlur stdDeviation="1.55738" />
                        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0.858333 0 0 0 0 0.95841 0 0 0 0 1 0 0 0 1 0" />
                        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1721_45" />
                    </filter>
                    <clipPath id="bgblur_1_1721_45_clip_path" transform="translate(-20.6832 -8.40437)">
                        <path d="M32.719 15.607C32.719 18.1505 30.6263 20.214 28.0469 20.214C25.4675 20.214 23.3747 18.1505 23.3747 15.607C23.3747 13.0636 25.4675 11 28.0469 11C30.6263 11 32.719 13.0636 32.719 15.607Z" />
                        <path d="M30.2756 21.7497H30.383C33.3955 21.7497 35.8338 24.154 35.8338 27.1245C35.8338 28.3962 34.7874 29.428 33.4977 29.428H25.2116C25.0436 29.428 24.9321 29.2889 24.9321 29.1209V27.2781C24.9321 25.6382 24.3486 24.1375 23.3908 22.9391C23.2012 22.7018 23.2546 22.3432 23.5322 22.2201C24.1994 21.9243 24.9311 21.7497 25.7108 21.7497H25.8181C25.8695 21.7497 25.9205 21.7582 25.9693 21.7744C26.6241 21.9909 27.3151 22.1336 28.0469 22.1336C28.7786 22.1336 29.4697 21.9909 30.1245 21.7744C30.1732 21.7582 30.2243 21.7497 30.2756 21.7497Z" />
                    </clipPath>
                    <linearGradient id="paint0_linear_1721_45" x1="11.4315" y1="9.0625" x2="19.8576" y2="34.7273" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#EFF1FF" />
                        <stop offset="1" stopColor="white" stopOpacity="0" />
                    </linearGradient>
                </defs>
            </svg>
        </SvgIcon>
    );
};

export default ExternalUserHeaderLogoIcon;
